module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "clipped": _vm.clipped,
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "value": "true"
    },
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {}, [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('layerPanel.home')))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "value": "true"
    },
    on: {
      "click": function($event) {
        _vm.showAnalytics = !_vm.showAnalytics;
        _vm.drawerSide = false
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("ac_unit")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('layerPanel.sensors')))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.addRemovePoiFromMap()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa-map-marker")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('layerPanel.poi')))])], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.$store.getters.getLayers), function(layer, index) {
    return [_c('v-list-tile', {
      key: layer.properties.id,
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.toggleModel(layer.properties.id, _vm.layersOn);
          _vm.addRemoveGeoJSONToMap(layer.properties.id);
          _vm.showAnalytics = true;
          _vm.getLayerInfo(layer.properties.id);
          _vm.drawerSide = true;
          _vm.map.invalidateSize(true)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-checkbox', {
      attrs: {
        "value": layer.properties.id
      },
      on: {
        "click": function($event) {}
      },
      model: {
        value: (_vm.layersOn),
        callback: function($$v) {
          _vm.layersOn = $$v
        },
        expression: "layersOn"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(layer.properties.name))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v(_vm._s(layer.properties.place))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
      staticClass: "tileCircle"
    }, [(layer.properties.meta.difficulty === 1) ? _c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-circle")]) : _vm._e(), _vm._v(" "), (layer.properties.meta.difficulty === 2) ? _c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("fa-circle")]) : _vm._e(), _vm._v(" "), (layer.properties.meta.difficulty === 3) ? _c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v("fa-circle")]) : _vm._e()], 1), _vm._v("\n                    \n                  "), (layer.properties.meta.trackSnowState === 3) ? _c('span', {
      staticClass: "tileFlake"
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-snowflake-o")])], 1) : _vm._e(), _vm._v(" "), (layer.properties.meta.trackSnowState === 2) ? _c('span', {
      staticClass: "tileFlake"
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("fa-snowflake-o")])], 1) : _vm._e(), _vm._v(" "), (layer.properties.meta.trackSnowState === 1) ? _c('span', {
      staticClass: "tileFlake"
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("fa-snowflake-o")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(layer.properties.meta.length) + " km")])], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "elevation-0, indigo",
    attrs: {
      "fixed": "",
      "app": "",
      "clipped-left": _vm.clipped
    }
  }, [_c('v-spacer')], 1), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', [_c('analytics', {
    class: {
      show: !_vm.showAnalytics
    }
  }), _vm._v(" "), _c('div', {
    class: {
      hide: !_vm.showAnalytics
    },
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('div', {
    class: {
      show: _vm.drawerSide
    },
    attrs: {
      "id": "elevChartdiv",
      "transition": "slide-y-reverse-transition"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "sidebar",
    attrs: {
      "fixed": "",
      "app": "",
      "right": "",
      "width": "400",
      "clipped": _vm.clipped
    },
    model: {
      value: (_vm.drawerSide),
      callback: function($$v) {
        _vm.drawerSide = $$v
      },
      expression: "drawerSide"
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerSide = !_vm.drawerSide
      }
    }
  }), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-media', {
    attrs: {
      "src": "https://thumbs.dreamstime.com/b/cross-country-ski-path-8252693.jpg",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.layerProps.name))]), _vm._v(" "), _c('h3', {
    staticClass: "subheading mb-0"
  }, [_vm._v(_vm._s(_vm.layerProps.place))])])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "infoCard"
  }, [(_vm.layerProps.meta.trackStatus === 1) ? _c('div', {
    staticClass: "skipathState",
    staticStyle: {
      "color": "#43A546"
    }
  }, [_c('v-icon', {
    attrs: {
      "aria-hidden": "true",
      "color": "green"
    }
  }, [_vm._v("fa-smile-o")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('sidebar.state.wellMaintained')))])], 1) : _vm._e(), _vm._v(" "), (_vm.layerProps.meta.trackStatus === 0) ? _c('div', {
    staticClass: "skipathState",
    staticStyle: {
      "color": "#F33A30"
    }
  }, [_c('v-icon', {
    attrs: {
      "aria-hidden": "true",
      "color": "red"
    }
  }, [_vm._v("fa-frown-o")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('sidebar.state.notMaintained')))])], 1) : _vm._e(), _vm._v(" "), (_vm.layerProps.meta.difficulty === 1) ? _c('div', {
    staticClass: "skipathDifficulty",
    staticStyle: {
      "color": "#4DA4F4"
    }
  }, [_c('v-icon', {
    attrs: {
      "aria-hidden": "true",
      "color": "blue"
    }
  }, [_vm._v("fa-circle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('sidebar.state.beginner')))])], 1) : _vm._e(), _vm._v(" "), (_vm.layerProps.meta.difficulty === 2) ? _c('div', {
    staticClass: "skipathDifficulty",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('v-icon', {
    attrs: {
      "aria-hidden": "true",
      "color": "red"
    }
  }, [_vm._v("fa-circle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('sidebar.state.medium')))])], 1) : _vm._e(), _vm._v(" "), (_vm.layerProps.meta.difficulty === 3) ? _c('div', {
    staticClass: "skipathDifficulty",
    staticStyle: {
      "color": "#000000"
    }
  }, [_c('v-icon', {
    attrs: {
      "aria-hidden": "true",
      "color": "black"
    }
  }, [_vm._v("fa-circle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('sidebar.state.difficult')))])], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-card-text', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "details body-1"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t('sidebar.length')) + ":")]), _c('span', {
    staticClass: "sidebarValues"
  }, [_vm._v(_vm._s(_vm.layerProps.meta.length) + " m ")])]), _vm._v(" "), _c('p', {
    staticClass: "details body-1"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t('sidebar.trackState')) + ":")]), _c('span', {
    staticClass: "sidebarValues"
  }, [_vm._v(_vm._s(_vm.layerProps.meta.trackStatus))])]), _vm._v(" "), _c('p', {
    staticClass: "details body-1"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t('sidebar.trackStateNote')) + ":")]), _c('span', {
    staticClass: "sidebarValues"
  }, [_vm._v(_vm._s(_vm.layerProps.meta.trackStateNote))])]), _vm._v(" "), _c('p', {
    staticClass: "details body-1"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t('sidebar.trackSnowState')) + ":")]), _vm._v(" "), (_vm.layerProps.meta.trackSnowState === 3) ? _c('span', {
    staticClass: "sidebarValues"
  }, [_c('v-icon', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("fa-snowflake-o")])], 1) : _vm._e(), _vm._v(" "), (_vm.layerProps.meta.trackSnowState === 2) ? _c('span', {
    staticClass: "sidebarValues"
  }, [_c('v-icon', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("fa-snowflake-o")])], 1) : _vm._e(), _vm._v(" "), (_vm.layerProps.meta.trackSnowState === 1) ? _c('span', {
    staticClass: "sidebarValues"
  }, [_c('v-icon', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("fa-snowflake-o")])], 1) : _vm._e(), _vm._v(" "), (_vm.layerProps.meta.trackSnowState === 0) ? _c('span', {
    staticClass: "sidebarValues"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("fa-snowflake-o")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("fa-snowflake-o")])], 1) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "details body-1"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t('sidebar.difficulty')) + ":")]), _c('span', {
    staticClass: "sidebarValues"
  }, [_vm._v(_vm._s(_vm.layerProps.meta.difficulty))])]), _vm._v(" "), (_vm.layerProps.meta.note) ? _c('p', {
    staticClass: "details body-1"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t('sidebar.note')) + ":")]), _c('span', {
    staticClass: "sidebarValues"
  }, [_vm._v(_vm._s(_vm.layerProps.meta.note))])]) : _vm._e()])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab41531e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 194
// module chunks = 1